import { Controller } from "@hotwired/stimulus"

// Chips that fill a date input, plus hidden inputs that must carry the same
// date. Each chip carries its date as its own value, so the server owns the
// arithmetic and the chip lights up whenever the input matches it.
export default class extends Controller {
  static targets = ["date", "chip", "mirror", "disclosure"]

  connect() {
    this.sync()
  }

  apply(event) {
    if (this.hasDisclosureTarget) this.disclosureTarget.open = true
    this.dateTarget.value = event.currentTarget.value
    this.sync()
  }

  sync() {
    const date = this.hasDisclosureTarget && !this.disclosureTarget.open ? "" : this.dateTarget.value

    this.chipTargets.forEach((chip) => chip.setAttribute("aria-pressed", chip.value === date))
    this.mirrorTargets.forEach((mirror) => { mirror.value = date })
  }
}
